import React, { useState, useEffect } from "react";
import "./Login.css";
import Header from "../../Components/Shared/Header/Header";
import Footer from "../../Components/Shared/Footer/Footer";
import Modal from "../../Components/Modal/Modal";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { getMessaging, getToken } from "firebase/messaging";
import { app } from "../../firebase";
import VivahApi from "../../api";
import authService from "../../services/auth.service";
function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loginMode, setLoginMode] = useState('email'); // 'email' | 'phone'
  const [forgot, setForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotStep, setForgotStep] = useState(0); // 0 = request code, 1 = confirm code
  const [confirmCode, setConfirmCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [modal, setModal] = useState({ isOpen: false, type: 'info', title: '', message: '' });
  const [redirectTo, setRedirectTo] = useState(null);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  // Show success message if redirected from email verification
  useEffect(() => {
    if (location.state?.message) {
      setModal({
        isOpen: true,
        type: 'success',
        title: 'Success',
        message: location.state.message
      });
      // Clear the state
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  // Handle redirect after modal closes
  useEffect(() => {
    if (redirectTo) {
      navigate(redirectTo.path, { state: redirectTo.state });
      setRedirectTo(null);
    }
  }, [redirectTo, navigate]);

  const closeModal = () => {
    setModal({ ...modal, isOpen: false });
  };

  const requestForToken = async () => {
    try {
      const currentToken = await getToken(getMessaging(app), {
        vapidKey: process.env.VAPID_KEY,
      });

      if (currentToken) {
        const result = await VivahApi.FirebaseToken.createToken(currentToken);
      } else {
        // Show permission request UI
        console.log(
          "No registration token available. Request permission to generate one."
        );
      }
    } catch (error) {
      console.log("An error occurred while retrieving token. ", error);
    }
  };

  const onSubmit = async (data) => {
    try {
      const res = loginMode === 'phone'
        ? await VivahApi.Auth.loginWithPhone('+91' + data.phone.replace(/^\+?91/, ''), data.password)
        : await VivahApi.Auth.login(data.email, data.password);
      console.log(res, "response");
      
      // Auth service throws error on failure, so if we get here, login succeeded
      // Tokens are already stored in localStorage by auth.service.js
      
      // Get user profile
      const details = await VivahApi.Auth.userMe();
      await requestForToken();

      // console.log(details, "profile");
      // Store username (for backward compatibility)
      const userProfile = details.data?.user || details.data;
      if (userProfile?.name) {
        window.localStorage.setItem("usermame", userProfile.name);
      }
      
      // Sync premium plan status into localStorage (works cross-device)
      if (userProfile?.isPremium === 'yes' && userProfile?.premiumPlanExpiry) {
        if (userProfile.premiumPlanExpiry > new Date().toISOString().slice(0, 10)) {
          window.localStorage.setItem("planName", userProfile.premiumPlanName || "Premium");
          window.localStorage.setItem("planExpiry", userProfile.premiumPlanExpiry);
        } else {
          window.localStorage.removeItem("planName");
          window.localStorage.removeItem("planExpiry");
        }
      }

      // If user is an admin, redirect to admin dashboard
      try {
        if (authService.isAdmin()) {
          window.location = "/admin/dashboard";
          return;
        }
      } catch (e) {
        console.warn('Failed to detect admin status:', e);
      }

      window.location = "/";
    } catch (e) {
      console.log(e);
      const errorData = e.response?.data;
      const errorMessage = errorData?.message || errorData?.error || e.message || "Invalid Email or Password";
      
      // Check if it's an email verification error
      if (errorMessage.includes('verification') || 
          errorMessage.includes('verify') || 
          errorMessage.includes('not confirmed') ||
          errorData?.error === 'Email verification required') {
        
        // Show detailed message
        const verificationMessage = errorData?.message || 
          "Your email is not verified. Please check your email for the verification code.";
        
        setModal({
          isOpen: true,
          type: 'warning',
          title: 'Email Verification Required',
          message: verificationMessage + "\n\nClick OK to go to the verification page."
        });
        
        // Set redirect destination
        setRedirectTo({
          path: "/verify-email",
          state: { email: data.email || '' }
        });
      } else {
        setModal({
          isOpen: true,
          type: 'error',
          title: 'Login Failed',
          message: errorMessage
        });
      }
    }
  };

  return (
    <>
      <Modal
        isOpen={modal.isOpen}
        onClose={closeModal}
        type={modal.type}
        title={modal.title}
        message={modal.message}
        confirmText="OK"
      />
      
      <div className="gla_page" id="gla_page">
        <a href="#gla_page" className="gla_top ti ti-angle-up gla_go"></a>
        <Header />
        <div
          className="gla_page_title gla_image_bck gla_wht_txt"
          data-color="#282828"
        >
          <div className="container text-left">
            <div className="row">
              <div className="col-md-8">
                <h1 className="gla_h1_title">Login</h1>
              </div>
              <div className="col-md-4">
                <div className="breadcrumbs">
                  <a href="#">Home</a>
                  <span>Login</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section id="gla_content" className="gla_content">
          <section className="gla_section">
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-xs-12 col-md-offset-3">
                  <div className="checkout">
                    <div className="checkout-row row">
                      {!forgot ? (
                        <div className="log-in col-md-6">
                          <br/>
                          <br/>
                          <br/>
                          <div className="box">
                            <p>I'm a returning customer</p>
                            
                            {/* Email verification notice */}
                            {location.state?.email && (
                              <div style={{
                                padding: '10px',
                                marginBottom: '15px',
                                backgroundColor: '#d4edda',
                                border: '1px solid #c3e6cb',
                                borderRadius: '4px',
                                color: '#155724'
                              }}>
                                <small>
                                  <strong>Note:</strong> New users must verify their email before logging in. 
                                  Check your email for the verification code.
                                </small>
                              </div>
                            )}
                            
                            {/* Login mode toggle */}
                            <div style={{ display: 'flex', marginBottom: 14, borderRadius: 6, overflow: 'hidden', border: '1px solid #ddd', width: 'fit-content' }}>
                              <button
                                type="button"
                                onClick={() => setLoginMode('email')}
                                style={{
                                  padding: '6px 18px', border: 'none', cursor: 'pointer',
                                  backgroundColor: loginMode === 'email' ? '#e91e63' : '#f5f5f5',
                                  color: loginMode === 'email' ? '#fff' : '#555',
                                  fontWeight: loginMode === 'email' ? 600 : 400,
                                }}
                              >Email</button>
                              <button
                                type="button"
                                onClick={() => setLoginMode('phone')}
                                style={{
                                  padding: '6px 18px', border: 'none', cursor: 'pointer',
                                  backgroundColor: loginMode === 'phone' ? '#e91e63' : '#f5f5f5',
                                  color: loginMode === 'phone' ? '#fff' : '#555',
                                  fontWeight: loginMode === 'phone' ? 600 : 400,
                                }}
                              >Mobile</button>
                            </div>

                            <form onSubmit={handleSubmit(onSubmit)}>
                              <div className="row">
                                <div className="col-md-12" style={{ marginBottom: 10 }}>
                                  {loginMode === 'phone' ? (
                                    <div style={{ display: 'flex', height: 42 }}>
                                      <span style={{
                                        display: 'flex', alignItems: 'center',
                                        padding: '0 10px', fontSize: 14, color: '#555',
                                        background: '#f5f5f5', border: '1px solid #ccc',
                                        borderRight: 'none', borderRadius: '4px 0 0 4px',
                                        flexShrink: 0,
                                      }}>+91</span>
                                      <input
                                        type="tel"
                                        {...register("phone")}
                                        placeholder="10-digit mobile number"
                                        maxLength={10}
                                        style={{
                                          flex: 1, height: '100%', padding: '0 12px',
                                          border: '1px solid #ccc', borderRadius: '0 4px 4px 0',
                                          fontSize: 14, outline: 'none', boxSizing: 'border-box',
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <input
                                      type="text"
                                      {...register("email")}
                                      placeholder="Email Address"
                                      className="input-text form-control"
                                    />
                                  )}
                                </div>
                                <div className="col-md-12">
                                  <input
                                    type="password"
                                    {...register("password")}
                                    placeholder="Password"
                                    className="input-text form-control"
                                  />
                                </div>
                              </div>
                              <div className="row  sign-up-btn">
                                <div className="d-flex">
                                  <button
                                    type="submit"
                                    title="Log in"
                                    className="button btn btn-default"
                                  >
                                    <em className="fa-icon">
                                      <i className="fa fa-unlock"></i>
                                    </em>
                                    <span>Log in</span>
                                  </button>

                                  <span
                                    className="forgot-pass"
                                    onClick={() => setForgot(true)}
                                  >
                                    {" "}
                                    Forgot Password
                                  </span>
                                </div>

                                <a href="/registration">Sign Up</a>
                              </div>
                              
                              {/* Link to email verification */}
                              <div className="row" style={{ marginTop: '10px' }}>
                                <div className="col-md-12 text-center">
                                  <small style={{ color: '#666' }}>
                                    Need to verify your email?{' '}
                                    <a href="/verify-email" style={{ color: '#c19d5f', fontWeight: 'bold' }}>
                                      Click here
                                    </a>
                                  </small>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      ) : (
                        <div className="log-in col-md-6">
                          <h3 className="title">Forgot Password</h3>
                          <div className="box">
                            <p>
                              We will send you password to your registered Email
                              Id
                            </p>
                            <div className="row">
                              <div className="col-md-12">
                                  {forgotStep === 0 ? (
                                    <input
                                      type="text"
                                      value={forgotEmail}
                                      onChange={e => setForgotEmail(e.target.value)}
                                      placeholder="Matrimony ID / Email /"
                                      className="input-text form-control"
                                    />
                                  ) : (
                                    <>
                                      <input
                                        type="text"
                                        value={confirmCode}
                                        onChange={e => setConfirmCode(e.target.value)}
                                        placeholder="Confirmation Code"
                                        className="input-text form-control"
                                      />
                                      <input
                                        type="password"
                                        value={newPassword}
                                        onChange={e => setNewPassword(e.target.value)}
                                        placeholder="New Password"
                                        className="input-text form-control"
                                      />
                                    </>
                                  )}
                              </div>
                            </div>
                              <button
                                type="button"
                                title="Submit"
                                className="button btn btn-default"
                                onClick={async () => {
                                  try {
                                    if (forgotStep === 0) {
                                      if (!forgotEmail) { setModal({ isOpen:true, type:'error', title:'Error', message:'Enter email' }); return; }
                                      await VivahApi.Auth.forgotPassword(forgotEmail);
                                      setModal({ isOpen:true, type:'success', title:'Code sent', message:'A confirmation code was sent to your email' });
                                      setForgotStep(1);
                                      return;
                                    }

                                    // confirm step
                                    if (!confirmCode || !newPassword) { setModal({ isOpen:true, type:'error', title:'Error', message:'Enter code and new password' }); return; }
                                    await VivahApi.Auth.confirmForgotPassword(forgotEmail, confirmCode, newPassword);
                                    setModal({ isOpen:true, type:'success', title:'Password reset', message:'Your password has been reset. Please login with the new password.' });
                                    setForgot(false);
                                    setForgotStep(0);
                                    setConfirmCode('');
                                    setNewPassword('');
                                  } catch (err) {
                                    console.error('Forgot password error', err);
                                    const message = err.response?.data?.message || err.message || 'Failed to reset password';
                                    setModal({ isOpen:true, type:'error', title:'Error', message });
                                  }
                                }}
                              >
                                <em className="fa-icon">
                                  <i className="fa fa-unlock"></i>
                                </em>
                                <span>{forgotStep === 0 ? 'Send Code' : 'Confirm'}</span>
                              </button>
                            <button
                              type="button"
                              title="Cancel"
                              className="button btn btn-danger danger"
                            >
                              <em className="fa-icon">
                                <i className="fa fa-unlock"></i>
                              </em>
                              <span onClick={() => setForgot(false)}>
                                Cancel
                              </span>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <Footer />
      </div>
    </>
  );
}

export default Login;
